import CommunicationsManager from "./manager";

export default CommunicationsManager;